export default __webpack_public_path__ + "static/media/met-before-bg.045a57d2.webp";